import React from "react"
import TaskCode from '../../Shared/TaskCode'


export default ({ touched, errors, setFieldValue, values, handleBlur, taskType }) => (
  <div className="row display-flex">
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">

      <fieldset className="fieldset">
        <legend>اطلاعات کالا جهت تولید</legend>

        <table className="table validator-table" style={{ marginBottom: 5 }}>
          <thead>
            <tr>
              <th className="text-center">ردیف</th>
              <th className="text-center">کد سفارش</th>
              <th className="text-center">دسته بندی</th>
              <th className="text-center">برند</th>
              <th className="text-center">نام کالا</th>
              {/* <th className="text-center">کد کالا</th> */}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>
                <TaskCode code={values.taskCode} />
              </td>
              <td>
                {values.product && values.product && values.product.category.name}
              </td>
              <td>
                {values.product && values.product && values.product.brand.name}
              </td>
              <td>
                {values.product && values.product && values.product.name}
              </td>
              {/* <td>
                {values.product && values.product && values.product.extraCode}
              </td> */}
            </tr>
          </tbody>
        </table>

      </fieldset>

    </div>

  </div>
);